export default __webpack_public_path__ + "static/media/Spinner.68d338a8.gif";